import type { JSX } from 'react';
import React from 'react';
import { ExclamationCircleFilled, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { BaseInput } from '@components';
import { HintText, InputLabel, InputWrapper } from '@components/input/styled.tsx';
import { getFieldError, isFieldErroneous } from '@routes/auth/___shared___/helpers.ts';
import type { FormField } from '@types';
import { Form } from 'antd';

export const renderChangePasswordInput = <T extends Record<string, boolean>>(
    passwordRequiredMsg: string,
    fieldName: string,
    fieldKey: string,
    label: string,
    placeholder: string,
    formFields: FormField[],
    isPasswordType: T,
    setIsPasswordType: React.Dispatch<React.SetStateAction<T>>,
    hintText?: string,
    showMismatch?: boolean,
    mismatchErrorMsg?: string,
    isMismatched?: (fields: FormField[]) => boolean,
): JSX.Element => (
    <InputWrapper>
        <InputLabel>{label}</InputLabel>
        {!!hintText && <HintText $showByDefault>{hintText}</HintText>}
        <Form.Item noStyle name={fieldName} rules={[{ required: true, message: passwordRequiredMsg }]}>
            <BaseInput
                suffixIcon={
                    isFieldErroneous(fieldName, formFields) ? (
                        <ExclamationCircleFilled
                            onClick={() => setIsPasswordType((prev) => ({ ...prev, [fieldKey]: !prev[fieldKey] }))}
                        />
                    ) : isPasswordType[fieldKey] ? (
                        <EyeOutlined onClick={() => setIsPasswordType((prev) => ({ ...prev, [fieldKey]: false }))} />
                    ) : (
                        <EyeInvisibleOutlined
                            onClick={() => setIsPasswordType((prev) => ({ ...prev, [fieldKey]: true }))}
                        />
                    )
                }
                type={isPasswordType[fieldKey] ? 'password' : 'text'}
                placeholder={placeholder}
                status={isFieldErroneous(fieldName, formFields) ? 'error' : ''}
                data-cy={`password-input-${fieldName}`}
            />
        </Form.Item>
        {isFieldErroneous(fieldName, formFields) && (
            <HintText $showByDefault className="has-error">
                {getFieldError(fieldName, formFields)}
            </HintText>
        )}
        {!!(showMismatch && fieldKey === 'repeat') && (
            <HintText $showByDefault={isMismatched ? isMismatched(formFields) : false} className="has-error">
                {mismatchErrorMsg}
            </HintText>
        )}
    </InputWrapper>
);
